import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.details', {
        url: '/details',
        component: 'companyUserDirectoriesManageAccountDetails',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/details/account-details.state.js